/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_Empty1Inputs */

const vi_cmspost_empty1 = /** @type {(inputs: Cmspost_Empty1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có bài viết nào khớp bộ lọc.`)
};

/**

* @param {Cmspost_Empty1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_empty1 = /** @type {((inputs?: Cmspost_Empty1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Empty1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_empty1(inputs)
});
export { cmspost_empty1 as "cmsPost_empty" }